module.exports = __webpack_public_path__ + "static/turquia-029-2f0ab04f3e2fccee6901cc91f358988c.jpg";